// extracted by mini-css-extract-plugin
module.exports = {"tab-container":"walkthroughTab_tab-container__Zr4bM","symbol-container":"walkthroughTab_symbol-container__Wh2xd","tab-name":"walkthroughTab_tab-name__pI0S0"};